// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const PauseIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="PauseIcon" ref={forwardedRef} {...props}>
      <path d="M6 16.002V4h2v12.002z" />
      <path d="M12 16V3.998h2V16z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const PauseIcon = /* @__PURE__ */ Object.assign(PauseIconComponent, {
  displayName: 'PauseIcon',
});
